import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homesix-about',
  templateUrl: './homesix-about.component.html',
  styleUrls: ['./homesix-about.component.scss']
})
export class HomesixAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
